import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const AgeRelatedChanges = lazyWithPreload(
  () => import('./AgeRelatedChanges'),
)
